import { makeStyles, tokens } from '@fluentui/react-components'

/**
 * Shared 20x20 circular badge visuals for mouse, document, and comments
 * context sources in the ContextBar header row.
 *
 * !important wins over Fluent Button appearance="subtle" slot backgrounds.
 */
export const useContextSourceBadgeStyles = makeStyles({
  badge: {
    width: tokens.spacingHorizontalXXL,
    height: tokens.spacingHorizontalXXL,
    minWidth: tokens.spacingHorizontalXXL,
    padding: 0,
    borderRadius: tokens.borderRadiusCircular,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  // Light brand surface + brand icon - selected / included as context.
  // Hover/press feedback is for clickable badges (document, comments).
  active: {
    backgroundColor: `${tokens.colorBrandBackground2} !important`,
    color: `${tokens.colorBrandForeground1} !important`,
    ':hover': {
      backgroundColor: `${tokens.colorBrandBackground2Hover} !important`,
      color: `${tokens.colorBrandForeground1} !important`,
    },
    ':active': {
      backgroundColor: `${tokens.colorBrandBackground2Pressed} !important`,
      color: `${tokens.colorBrandForeground1} !important`,
    },
  },
  // Same rest colors as active, without hover/press - visualization-only badges.
  activeStatic: {
    backgroundColor: `${tokens.colorBrandBackground2} !important`,
    color: `${tokens.colorBrandForeground1} !important`,
  },
  // Transparent / white with dark outline icon - available but not included.
  inactive: {
    backgroundColor: `transparent !important`,
    color: `${tokens.colorNeutralForeground1} !important`,
    ':hover': {
      backgroundColor: `${tokens.colorNeutralBackground1Hover} !important`,
      color: `${tokens.colorNeutralForeground1} !important`,
    },
    ':active': {
      backgroundColor: `${tokens.colorNeutralBackground1Pressed} !important`,
      color: `${tokens.colorNeutralForeground1} !important`,
    },
  },
  // Muted - nothing to include (e.g. no mouse selection / no comments).
  disabled: {
    backgroundColor: `transparent !important`,
    color: `${tokens.colorNeutralForegroundDisabled} !important`,
  },
  // Lets inverted Fluent tooltips show on visually-disabled buttons.
  tooltipAnchor: {
    display: 'inline-flex',
    flexShrink: 0,
  },
})
